ko.originalApplyBindings = ko.applyBindings;
ko.applyBindings = function () {
    var args = arguments;
    if ( !args || !args[1] ) {
        if ( window.console && window.console.trace ) {
            window.console.trace( 'ko.applyBindings with a null or undefined element is not allowed.' );
        }
        return;
    }
    ko.originalApplyBindings.apply( this, args );
};

ko.bindingHandlers.addCssClass = {
    update: function (element, valueAccessor) {
        // First get the latest data that we're bound to
        var value = valueAccessor();

        // Next, whether or not the supplied model property is observable, get its current value
        var valueUnwrapped = ko.utils.unwrapObservable(value) || '';

        // Now manipulate the DOM element
        if (typeof valueUnwrapped.overwrite != 'undefined' && valueUnwrapped.overwrite === true) {
            $(element).removeClass();
        }

        if (typeof valueUnwrapped.className != 'undefined')
            $(element).addClass(valueUnwrapped.className);
        else {
            $(element).addClass(valueUnwrapped);
        }
    }
};

ko.bindingHandlers.giveChangeFeedback = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        // First get the latest data that we're bound to
        var value = valueAccessor(), allBindings = allBindingsAccessor();

        // Next, whether or not the supplied model property is observable, get its current value
        var valueUnwrapped = ko.utils.unwrapObservable(value);

        if (valueUnwrapped == 'parent') {
            $(element).parent().animate({ backgroundColor: '#D6DCE4' }, 800).animate({ backgroundColor: '#fff' }, 800);
        } else if (valueUnwrapped == 'this') {
            $(element).animate({ backgroundColor: '#D6DCE4' }, 800).animate({ backgroundColor: '#fff' }, 800);
        }
    }
};

ko.bindingHandlers.fadeChangeTransition = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        $(element).hide();
        $(element).fadeIn('slow');
    }
};

ko.bindingHandlers.slideVisible = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var value = valueAccessor();
        var valueUnwrapped = ko.utils.unwrapObservable(value);

        if (valueUnwrapped === true) {
            $(element).show();
        } else {
            $(element).hide();
        }
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var value = valueAccessor();
        var valueUnwrapped = ko.utils.unwrapObservable(value);
        var duration = allBindingsAccessor.get('slideDuration');

        if (valueUnwrapped === true) {
            if (duration != undefined) {
                $(element).slideDown('fast').delay(duration).slideUp('fast');
            } else {
                $(element).slideDown('fast');
            }
        } else {
            $(element).slideUp('fast');
        }
    }
};

ko.bindingHandlers.fadeVisible = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var value = valueAccessor();
        var valueUnwrapped = ko.utils.unwrapObservable(value);


        if (valueUnwrapped === true) {
            $(element).show();
        } else {
            $(element).hide();
        }
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var value = valueAccessor();
        var valueUnwrapped = ko.utils.unwrapObservable(value);

        if (valueUnwrapped === true) {
            $(element).fadeIn('slow');
        } else {
            $(element).hide();
        }
    }
};

ko.bindingHandlers.fadeInOutVisible = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var value = valueAccessor();
        var valueUnwrapped = ko.utils.unwrapObservable(value);


        if (valueUnwrapped === true) {
            $(element).show();
        } else {
            $(element).hide();
        }
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var value = valueAccessor();
        var valueUnwrapped = ko.utils.unwrapObservable(value);

        if (valueUnwrapped === true) {
            $(element).fadeIn('slow');
        } else {
            $(element).fadeOut('slow');
        }
    }
};


ko.bindingHandlers.datepicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {

        //initialize datepicker with some optional options
        var options = allBindingsAccessor().datepickerOptions || {};
        $(element).datepicker(options);

        //handle the field changing
        ko.utils.registerEventHandler(element, "change", function () {
            var observable = valueAccessor();
            observable($(element).datepicker("getDate"));
        });

        //handle disposal (if KO removes by the template binding)
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $(element).datepicker("destroy");
        });

    },
    update: function (element, valueAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor()),
            current = $(element).datepicker("getDate");

        if (value - current !== 0) {
            $(element).datepicker("setDate", value);
        }
    }
};

ko.bindingHandlers.catalogPopdownQtip = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var value = valueAccessor();
        var valueUnwrapped = ko.utils.unwrapObservable(value);

        var option = valueUnwrapped.Option;
        //        var catalogChangeMethod = valueUnwrapped.ChangeMethod;

        var d = document;

        var list = d.createElement("ul");
        list.className = "hide " + option.ClassName() + "OptionList";

        $.each(option.Choices(), function (i, e) {
            var listElement = d.createElement("li");
            var link = null;

            if (e.Selected()) {
                listElement.className = "selected";
                link = $("<span/>");
            } else {
                link = $("<a/>");
                //$(link).click(function () { catalogChangeMethod(option.CatalogKeyField(), e.Value()); });
                //$(link).attr({ onclick: "javascript:function(){" + catalogChangeMethod(option.CatalogKeyField(), e.Value()) + "}" });

                $(link).attr({ onclick: "javascript:SetChangedCatalogAndPost('" + viewModel.CatalogKeyField() + "', '" + e.Value() + "');" });
            }

            $(link).html(e.Text()); // .attr({ href: "javascript:;" });

            $(listElement).append(link);
            list.appendChild(listElement);
        });

        $(element).after(list);

        var classChange = "optionButtonHover";

        $(element).qtip({
            overwrite: false,
            content: {
                text: $(element).siblings("." + option.ClassName() + "OptionList").html(),
                title: {
                    button: true
                }
            },
            position: {
                my: "top left",
                at: "bottom left",
                adjust: {
                    method: "none"
                },
                target: false
            },
            style: {
                classes: "ui-tooltip-stuller-down ui-tooltip-shadow ui-tooltip-rounded",
                tip: {
                    corner: false,
                    mimic: "center"
                }
            },
            show: {
                event: "click",
                solo: true
            },
            hide: {
                fixed: true,
                leave: false,
                delay: false,
                event: "unfocus keyup"
            },
            events: {
                show: function (event, api) {
                    $(classChange).removeClass(classChange);
                    CloseAllQtips();
                    api.elements.target.addClass(classChange);
                    api.elements.target.parent().addClass(classChange);
                },
                hide: function (event, api) {
                    if (api.elements.target.hasClass(classChange)) {
                        api.elements.target.removeClass(classChange);
                        api.elements.target.parent().removeClass(classChange);
                    }
                }
            }
        });
    }
};

ko.bindingHandlers.stullerQtip = {
    update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var $qTip = $(element);
        var params = ko.toJS(valueAccessor());
        if (params == null) {
            $qTip.removeData("qtip");
            return;
        }

        params = $.extend({}, {
            contentRelationship: 'child',
            showHideOnClick: false,
            delayOnShow: 0,
            delayOnHide: 0,
            showArrow: true,
            viewport: 'window',
            adjustMethod: "flip",
            showOnLoad: false,
            target: false,
            adjustXCoord: 0,
            adjustYCoord: 0,
            showSolo: false,
            width: false,
            trackEvent: false,
            trackEventName: "",
            trackEventAction: "",
            showOnMobile: false
        }, params);

        if (params.viewport == 'window')
            params.viewport = $(window);
        else
            params.viewport = $(params.viewport);


        var $qTipHoverElement = $(element);

        if (params.contentRelationship == "sibling") {
            $qTipHoverElement = $qTip.siblings(params.contentElement);
        }
        else if (params.contentRelationship == "child") {
            $qTipHoverElement = $qTip.children(params.contentElement);
        }
        else if (params.contentRelationship == "child-find") {
            $qTipHoverElement = $qTip.children().find(params.contentElement);
        }

        var hasTouchDevice = Modernizr && Modernizr.touch;

        var showEvent = params.showHideOnClick ? 'click' : 'mouseenter';
        var hideEvent = params.showHideOnClick ? 'click' : 'mouseleave';

        if (hasTouchDevice) {
            showEvent += " touchstart";
            hideEvent += " touchstart"
        }

        setTimeout(function () {
            $qTip
                .qtip({
                    overwrite: true,
                    content: {
                        text: $qTipHoverElement.html(),
                        title: {
                            text: params.title,
                            button: params.showHideOnClick
                        }
                    },
                    position: {
                        my: params.myPosition,
                        at: params.atPosition,
                        viewport: params.viewport,
                        target: params.target,
                        adjust: {
                            method: params.adjustMethod,
                            x: params.adjustXCoord,
                            y: params.adjustYCoord
                        }
                    },
                    style: {
                        //height: 100,
                        classes: params.classes + ' ui-tooltip-rounded',
                        tip: {
                            corner: params.showArrow ? true : false,
                            mimic: "center"
                        },
                        width: params.width
                    },
                    show: {
                        delay: params.delayOnShow,
                        event: showEvent,
                        solo: params.showSolo,
                        ready: params.showOnLoad
                    },
                    hide: {
                        fixed: true, // !params.closeManually && !params.showOnClick ? true : false,
                        leave: params.showHideOnClick ? true : false,
                        event: hideEvent,
                        delay: params.showHideOnClick ? false : params.delayOnHide
                    },
                    events: {
                        show: function(event, api) {
                            if (!params.showHideOnClick && !params.showOnMobile && $("#bootstrap-visible-xs").is(":visible")) {
                                event.preventDefault();
                                return;
                            }

                            if (params.delayOnHide > 0) {
                                $(params.classChange).removeClass(params.classChange);
                                CloseAllQtips();
                            }
                            api.elements.target.addClass(params.classChange);
                            if (params.trackEvent == true) {
                                ProductPageEventTrack(params.trackEventName, params.trackEventAction);
                            }
                        },
                        hide: function(event, api) {
                            if (api.elements.target.hasClass(params.classChange)) {
                                api.elements.target.removeClass(params.classChange);
                            }
                        },
                        events: {
                            move: function(event, api, position, viewport) {
                                if (position.adjusted) { position.bottom -= api.options.position.adjust.y }
                            }
                        }
                    }
                })
        }, 200);
    }
};

ko.bindingHandlers.numericEntry = {
    init: function (element, valueAccessor) {
        $(element).on("keydown", handleNumericEntry);
    }
};
ko.extenders.decimalPlacesAllowed = function (target, decimalsAllowed) {
    var result = ko.computed({
        read: target,
        write: function (newValue) {
            var current = target();
            var valueToWrite = newValue;
            if (current === newValue) {
                return;
            }
            //if the incoming value is more than the allowed decimal places, then round to the nearest allowed decimal place
            if (newValue != null) {
                let parts = newValue.split('.', 2);
                if (parts.length > 1 && parts[1].length > decimalsAllowed) {
                    parts[1] = parts[1].substring(0, decimalsAllowed);
                    valueToWrite = parts.join('.');
                }
            }
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else if (newValue !== current) {
                target.notifySubscribers(valueToWrite);
            }
        }
    });
    result(target());

    return result;
};

ko.extenders.numeric = function (target, precision) {
    //create a writable computed observable to intercept writes to our observable
    var result = ko.computed({
        read: target,  //always return the original observables value
        write: function (newValue) {
            if (newValue) {
                newValue = newValue.toString().replace(/,/g, ''); //remove the commas that people are adding to their numeric fields.
            }
            var current = target(),
                roundingMultiplier = Math.pow(10, precision),
                newValueAsNum = isNaN(newValue) ? 0 : parseFloat(+newValue),
                valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

            //only write if it changed
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else {
                //if the rounded value is the same, but a different value was written, force a notification for the current field
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({ notify: 'always' });

    //initialize with current value to make sure it is rounded appropriately
    result(target());

    //return the new computed observable
    return result;
};

ko.extenders.throttleDeferred = function (target, timeout) {
    target.throttleEvaluation = timeout;
    return target;
};

/*
 * ****************************************************************************************************
 * This file contains custom KnockoutJS bindings for OWL Carousel (http://owlgraphic.com/owlcarousel/).
 * It is a wrapper for the built in 'template' binding.
 *
 * @author      Hauke Jaeger, hauke.jaeger@googlemail.com
 * @license     MIT http://www.opensource.org/licenses/mit-license.php
 * ****************************************************************************************************
 */

/**
    * Helper function that refreshes the items of the given owl instance.
    *
    * @param {{ $owlWrapper: jQuery, $owlItems: jQuery, $userItems: jQuery, itemsAmount: number }} owl
    *          The owl carousel instance that should be refreshed
    */
var refreshOwl = function (owl) {
    // find all owl items that are currently wrapped in the owl wrapper element
    owl.$owlItems = owl.$owlWrapper.children(".owl-item");

    // extract the elements that are wrapped in the owl items
    owl.$userItems = owl.$owlItems.children();
    owl.itemsAmount = owl.$userItems.length;

    // TODO: check if items have been removed and adjust owl's internal current position

    // recalculate internal values
    owl.calculateAll();

    // refresh pagination
    owl.updatePagination();

    // refresh the controls block (make it visible)
    owl.updateControls();
};

/**
    * Helper function for creating an options object that can be passed to ko.bindingHandlers.template.init as a value for
    * the 'valueAccessor' parameter.
    *
    * @param {{data: *, as: string, afterRender: function, afterAdd: function, beforeRemove: function}} options
    * @param {function} afterRender
    * @returns {{foreach: *, as: string, afterRender: function, afterAdd: function, beforeRemove: function}}
    */
var makeTemplateBindingOptions = function (options, afterRender) {
    var templateOptions = {
        foreach: options.data,
        as: options.as,
        afterRender: afterRender,
        afterAdd: options.afterAdd,
        beforeRemove: options.beforeRemove
    };

    if (options.afterRender) {
        var userAfterRender = options.afterRender;

        templateOptions.afterRender = function (element, data) {
            if (afterRender) {
                afterRender.call(data, element, data);
            }

            userAfterRender(data, element, data);
        };
    }

    return templateOptions;
};

ko.bindingHandlers.owlCarousel = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        // the options that have been configured with the owlCarousel binding
        var options = ko.utils.unwrapObservable(valueAccessor());

        // the bound element as a jQuery object
        var $elem = $(element);

        // a dummy <div> element
        var $dummy = null;

        // check whether the owlCarousel binding has beeing initialized on an empty container element
        if ($elem.children().length === 0) {
            // create a dummy element and add it to the owlContainer element
            // this is necessary for initializing OWL Carousel without errors.
            $dummy = $('<div class="knockout-owlCarousel-dummy"></div>');
            $elem.append($dummy);
        }

        // initialize owl carousel
        var owlOptions = options.owlOptions || {};
        $elem.owlCarousel(owlOptions);

        // the owl instance that has just been created
        var owl = $elem.data("owlCarousel");

        // remove the dummy element if it was required
        if ($dummy !== null) {
            owl.removeItem(0);
        }

        // register a callback that is being executed when the element is removed
        // in that case the carousel is no longer required and can be destroyed
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            if (owl) {
                owl.destroy();
            }
        });

        // create options for the template binding with a afterRender event hook
        // that causes the carousel to refresh its internal state
        var templateOptions = makeTemplateBindingOptions(options, function () {
            refreshOwl(owl);
        });

        return ko.bindingHandlers.template.init(owl.$owlWrapper[0], function () { return templateOptions; }, allBindingsAccessor, viewModel, bindingContext);
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        // the options that have been configured with the owlCarousel binding
        var options = ko.utils.unwrapObservable(valueAccessor());

        // the bound element as a jQuery object
        var $elem = $(element);

        // the owl instance that has been associated with the element
        var owl = $elem.data("owlCarousel");

        // jjf - added this because the refresh was not always being called when the item list was updated.
        //       not only that, but some list initializations were not complete.  /shrug
        if (typeof owl != 'undefined') {
            setTimeout(function() { refreshOwl(owl); }, 200);
        }

        // create options for the template binding with a afterRender event hook
        // that causes the carousel to refresh its internal state
        var templateOptions = makeTemplateBindingOptions(options, function (element, data) {
            refreshOwl(owl);
        });

        ko.bindingHandlers.template.update(owl.$owlWrapper[0], function () { return templateOptions; }, allBindingsAccessor, viewModel, bindingContext);
    }
};

// only works with version 3.0 and above :( :( :(
//ko.bindingHandlers.optionsBind = {
//    preprocess: function (value, key, addBinding) {
//        addBinding('optionsAfterRender', 'function(option, item) { ko.bindingHandlers.optionsBind.applyBindings(option, item, ' + value + ') }');
//    },
//    applyBindings: function (option, item, bindings) {
//        if (item !== undefined) {
//            option.setAttribute('data-bind', bindings);
//            ko.applyBindings(ko.contextFor(option).createChildContext(item), option);
//        }
//    }
//};

ko.bindingHandlers.scroll = {


    updating: true,

    init: function (element) {
        var self = this
        self.updating = true;
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $(window).off("scroll.ko.scrollHandler");
            self.updating = false;
        });
    },


    update: function (element, valueAccessor, allBindingsAccessor) {
        var props = allBindingsAccessor().scrollOptions;
        var loadFunc = props.loadFunc;
        var load = ko.utils.unwrapObservable(valueAccessor());
        var self = this;

        self.IsInfiniteScrollingElementVisible = function (element) {
            var $elem = $(element);
            var $window = $(window);

            var docViewTop = $window.scrollTop();
            var docViewBottom = docViewTop + $window.height();

            var elemTop = $elem.offset().top;
            var elemBottom = elemTop + $elem.height();

            return elemBottom <= docViewBottom;
        }

        if (load) {
            element.style.display = "";
            $(window).on("scroll.ko.scrollHandler", function () {
                var loadingElementIsVisible = self.IsInfiniteScrollingElementVisible(element);
                if (loadingElementIsVisible) {
                    if (self.updating) {
                        loadFunc()

                        self.updating = false;
                    }
                }
                else {
                    self.updating = true;
                }
            });
        }
        else {
            element.style.display = "none";
            $(window).off("scroll.ko.scrollHandler")
            self.updating = false;
        }
    }
}

//connect items with observableArrays
ko.bindingHandlers.sortableList = {
    init: function (element, valueAccessor) {
        var list = valueAccessor();
        $(element).sortable({
            update: function (event, ui) {
                //retrieve our actual data item
                var item = ui.item.tmplItem().data;
                //figure out its new position
                var position = ko.utils.arrayIndexOf(ui.item.parent().children(), ui.item[0]);
                //remove the item and add it back in the right spot
                if (position >= 0) {
                    list.remove(item);
                    list.splice(position, 0, item);
                }
                ui.item.remove();
            }
        });
    }
};

//control visibility, give element focus, and select the contents (in order)
ko.bindingHandlers.visibleAndSelect = {
    update: function (element, valueAccessor) {
        ko.bindingHandlers.visible.update(element, valueAccessor);
        if (valueAccessor()) {
            setTimeout(function () {
                $(element).focus().select();
            }, 0); //new tasks are not in DOM yet
        }
    }
}

ko.bindingHandlers.enterkey = {
    init: function ( element, valueAccessor, allBindings, viewModel ) {
        var callback = valueAccessor();
        $(element).keypress(function (event) {
            var keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(viewModel);
                return false;
            }
            return true;
        });
    }
};

ko.bindingHandlers.readonly = {
    update: function(element, valueAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor());
        if (value && element.readOnly)
            element.removeAttribute("readonly");
        else if ((!value) && (!element.readOnly))
            element.readOnly = true;
    }
};

ko.bindingHandlers.select2 = {
    after: ["options", "value"],
    init: function ( el, valueAccessor, allBindingsAccessor, viewModel ) {
        $( el ).select2( ko.unwrap( valueAccessor() ) );
        ko.utils.domNodeDisposal.addDisposeCallback( el, function () {
            $( el ).select2( 'destroy' );
        } );
    },
    update: function ( el, valueAccessor, allBindingsAccessor, viewModel ) {
        var allBindings = allBindingsAccessor();
        var select2 = $( el ).data( "select2" );
        if ( "value" in allBindings ) {
            var value = ko.unwrap( allBindings.value );
            if (typeof value === 'object' && value != null)
                return;

            var newValue = "" + value;
            if ( ( allBindings.select2.multiple || el.multiple ) && newValue.constructor !== Array ) {
                select2.val( [newValue.split( "," )] );
            }
            else {
                select2.val( [newValue] );
            }
        }
    }
};

ko.bindingHandlers.slider = (function () {
    var sliderHasMultiSelectValues = function (options) {
        return options.range && (options.range != 'min' && options.range != 'max');
    };

    var changeObservable = function (options, observable, ui) {
        if (sliderHasMultiSelectValues(options)) {
            var obj = ko.unwrap(observable)
            obj.Minimum(ui.values[0]);
            obj.Maximum(ui.values[1]);
        } else
            observable(ui.value);
    };

    var setSliderOptions = function(element, valueAccessor, allBindingsAccessor) {
        var options = allBindingsAccessor().sliderOptions || {};
        var originalSlide = options.slide;
        var originalChange = options.change;

        var obs = valueAccessor();
        if ( !sliderHasMultiSelectValues( options ) ) {
            options.value = obs()
        }
        else {
            var obj = ko.unwrap(obs);
            options.values = [obj.Minimum(), obj.Maximum()]
        }
        $(element).slider(options);
        if (options.pips) {
            $(element).slider('pips', options.pips);
        }

        var eventOptions = {
            "slide": function (event, ui) {
                if (originalSlide)
                    originalSlide.apply(this, arguments);

                var opt = $(this).slider('option');
                if (sliderHasMultiSelectValues(opt) && ((ui.values[1] - ui.values[0]) < opt.step)) {
                    return false;
                }
                changeObservable(opt, valueAccessor(), ui);
            },
            "change": function (event, ui) {
                if (originalChange)
                    originalChange.apply(this, arguments);

                var opt = $(this).slider('option');
                if (sliderHasMultiSelectValues(opt) && ((ui.values[1] - ui.values[0]) < opt.step)) {
                    return false;
                }
                changeObservable(opt, valueAccessor(), ui);
            }
        };

        $(element).slider(eventOptions);
    };
    return{
        init: function(element, valueAccessor, allBindingsAccessor) {
            setSliderOptions(element, valueAccessor, allBindingsAccessor);
            ko.utils.domNodeDisposal.addDisposeCallback(element,
                function () {
                    $(element).slider("pips", "destroy");
                    $(element).slider("destroy");
                });
        },
        update: function(element, valueAccessor, allBindingsAccessor) {
            setSliderOptions(element, valueAccessor, allBindingsAccessor);
        }
    }
}() );

ko.virtualElements.allowedBindings.loadTemplate = true;
ko.bindingHandlers.loadTemplate = (function() {

    var encodeId = function ( s ) {
        if (s === "") return "_";
        var re = new RegExp("[^a-zA-Z0-9-]", "g");
        return s.replace(re, function(m) {
                return "_" + m[0].charCodeAt(0).toString(16) + "_";
            });
    };

    var loadingTemplatesPromises = [];

    var loadTemplate = function ( template ) {
        var dfd = $.Deferred();
        var id = encodeId(template);
        if ( document.getElementById( id ) == null ) {

            var loadingTemplate = $.grep( loadingTemplatesPromises, function ( p ) { return p.id == id })[0];
            if ( loadingTemplate != null ) {
                loadingTemplate.promise.always( function () { dfd.resolve() } );
                return dfd.promise();
            }
            var v = window["globalScriptVersion"];
            if ( !v || v.toLowerCase() == "test" )
                v = $.now();

            loadingTemplatesPromises.push(
                {
                    id: id,
                    promise: $.get( template, { "v": v }, function ( result ) {
                        var existingTemplate = $( "#" + id )[0];
                        if ( existingTemplate == null ) {
                            var sc = "<script type=\"text/html\" id=\"" + id + "\">" + result + "</script>";
                            $( "body" ).append( sc );
                        }
                    }).always( function () {
                        dfd.resolve();
                    })
                });
        } else {
            dfd.resolve();
        }

        return dfd.promise();
    };

    var getModifiedValueAccessor = function(valueAccessor) {
        return function() {
            var value = ko.utils.unwrapObservable(valueAccessor());
            if (value.name) {
                return $.extend({}, value, { name: encodeId(value.name) });
            }
            return encodeId(value);
        };
    };

    return {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            return ko.bindingHandlers.template.init(element,
                getModifiedValueAccessor(valueAccessor),
                allBindings,
                viewModel,
                bindingContext);
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = ko.utils.unwrapObservable( valueAccessor() );
            var template = value.name || value;

            var self = this;
            if ( value.data ) {
                var data = ko.utils.unwrapObservable(value.data);
                if ( data.AfterRender )
                    value.afterRender = data.AfterRender;
            }
            $.when(loadTemplate(template))
                .then( function () {
                        ko.bindingHandlers.template.update.call( self,
                            element,
                            getModifiedValueAccessor( valueAccessor ),
                            allBindings,
                            viewModel,
                            bindingContext );
                });
        }
    };
}());

ko.bindingHandlers.htmlWithBinding = {
    'init': function () {
        return { 'controlsDescendantBindings': true };
    },
    'update': function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        ko.utils.setHtml(element, valueAccessor());
        let callback = allBindings.get('htmlWithBindingAfterRender')
        if (callback != null && typeof callback === "function") {
            callback();
        }
        let skipApplyToDescendants = allBindings.get('htmlWithBindingSkipApplyToDescendants')
        if (skipApplyToDescendants !== true) {
            ko.applyBindingsToDescendants(bindingContext, element);
        }
    }
};

var popoverDomDataTemplateKey = '__popoverTemplateKey__';

ko.bindingHandlers.popover = {

    init: function (element) {
        var $element = $(element);

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            if ($element.data('bs.popover')) {
                $element.popover('destroy');
            }
        });
    },

    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var $element = $(element),
            value = ko.unwrap(valueAccessor()),
            options = (!value.options && !value.template ? ko.unwrap(value) : ko.unwrap(value.options)) || {};

        var triggerIsCustom = false;

        if (options.trigger == null) {
            options.trigger = 'focus';
        }

        if (value.template) {
            // use unwrap to track dependency from template, if it is observable
            ko.unwrap(value.template);

            var id = ko.utils.domData.get(element, popoverDomDataTemplateKey);
            var renderPopoverTemplate = function (eventObject) {

                if (eventObject && eventObject.type === 'inserted') {
                    $element.off('shown.bs.popover');
                }

                var template = ko.unwrap(value.template),
                    internalModel;

                if (typeof template === 'string') {
                    internalModel = {
                        $$popoverTemplate: $.extend({
                            name: value.template,
                            data: value.data
                        }, value.templateOptions)
                    };

                } else {
                    internalModel = {
                        $$popoverTemplate: value.template
                    };
                }

                var childContext = bindingContext.createChildContext(bindingContext.$rawData, null, function (context) {
                    ko.utils.extend(context, internalModel);
                });

                ko.applyBindingsToDescendants(childContext, document.getElementById(id));

                // bootstrap's popover calculates position before template renders,
                // so we recalculate position, using bootstrap methods
                var $popover = $('#' + id).parents('.popover'),
                    popoverMethods = $element.data('bs.popover'),
                    offset = popoverMethods.getCalculatedOffset(options.placement || 'right', popoverMethods.getPosition(), $popover.outerWidth(), $popover.outerHeight());

                popoverMethods.applyPlacement(offset, options.placement || 'right');
            };

            // if there is no generated id - popover executes first time for this element
            if (!id) {
                id = 'ks-popover-' + createGuid();
                ko.utils.domData.set(element, popoverDomDataTemplateKey, id);

                // place template rendering after popover is shown, because we don't have root element for template before that
                $element.on('shown.bs.popover inserted.bs.popover', renderPopoverTemplate);
            }

            options.content = '<div id="' + id + '" ><div data-bind="template: $$popoverTemplate"></div></div>';
            options.html = true;
        }

        var popoverData = $element.data('bs.popover');

        if (!popoverData) {

            if (options.target != null) {
                options.html = true;
                options.content = function () {
                    if (options.targetIsChild) {
                        return $(this).children(options.target).html();
                    }
                    if (options.directTarget) {
                        return $(options.target).html();
                    }
                    return $(this).siblings(options.target).html();
                };
            }

            $element.popover(options);

            $element.on('shown.bs.popover inserted.bs.popover', function () {
                (options.container ? $(options.container) : $element.parent()).one('click', '[data-dismiss="popover"]', function () {
                    $element.popover('hide');
                });
            });
        } else {
            ko.utils.extend(popoverData.options, options);
            if (popoverData.options.content) {
                $element.popover('show');
            } else {
                $element.popover('hide');
            }
        }
    }
};

ko.bindingHandlers.runOnInit = {
    init: function(elem, valueAccessor) {
        valueAccessor()();
    }
};
ko.virtualElements.allowedBindings.runOnInit = true;

ko.bindingHandlers.runOnUpdate = {
    update: function (elem, valueAccessor) {
        valueAccessor()();
    }
};
ko.virtualElements.allowedBindings.runOnUpdate = true;
